import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { FieldTypeConfig } from "@ngx-formly/core";
import { FieldType } from "@ngx-formly/material/form-field";
import { isObservable, Observable, of } from "rxjs";

@Component({
  selector: "lib-formly-specialty-icon-select-type",
  standalone: false,
  templateUrl: "./formly-specialty-icon-type.component.html",
  styleUrls: ["./formly-specialty-icon-type.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlySpecialtyIconTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  selectOptions: any[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    const opts = this.props.options;

    if (isObservable(opts)) {
      opts.subscribe(o => (this.selectOptions = o ?? []));
    } else if (Array.isArray(opts)) {
      this.selectOptions = opts;
    }
  }

  get selectOptions$(): Observable<any[]> {
    const opts = this.props.options;

    if (isObservable(opts)) {
      return opts;
    }

    if (Array.isArray(opts)) {
      return of(opts);
    }
    return of([]);
  }

  get selectedOption() {
    return this.selectOptions.find(o => o.value === this.formControl.value);
  }
}
